import React, { Component } from "react";

import Api from "../../../lib/componentApi";
import mixpanel from "../../../lib/mixPanel";

import { GlobalConsumer } from "../../../context/GlobalContext";

import Login from "../../../routes/screens/Auth/Login";

import NavbarLink from "./NavbarLink";

class Navbar extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loginSection: false,
      signupSection: false
    };
  }
  handleAuth = section => {
    this.setState({
      [section]: true
    });
  };
  handleLogout = event => {
    event.preventDefault();
    // eslint-disable-next-line
    if (__isBrowser__) {
      localStorage.removeItem("deliveryDetails");
      Api.get("/api/logout", {}, (response, errors) => {
        if (errors) {
          if (errors === 503) {
            this.setState(() => {
              throw errors;
            });
          } else {
            console.log(errors);
          }
        } else if (response.code) {
          console.log(response, "code-logout");
        } else {
          window.location.href = "/";
        }
      });
    }
  };
  onClose = ({ token }) => {
    this.setState(
      {
        loginSection: false,
        signupSection: false
      },
      () => {
        if (token) {
          location.reload(true);
        }
      }
    );
  };
  render() {
    const { signupSection, loginSection } = this.state;
    return (
      <nav className="hide-xs hide-static">
        <div className="container">
          <div>
            <a href="/">
              <img src="/svg/logo-blue.svg" />
            </a>
          </div>
          {(signupSection && (
            <Login firstSignup={true} onClose={this.onClose} />
          )) || <noscript />}
          {(loginSection && <Login onClose={this.onClose} />) || <noscript />}
          <GlobalConsumer>
            {({ allAmount, user, basketData }) => {
              const itemCount =
                (basketData && basketData.items && basketData.items.length) ||
                0;
              const authed = !!(user && user.uid);
              return (
                <ul>
                  {/*TODO: refactor here*/}
                  <NavbarLink
                    title="Our Mission"
                    href="why-local-e"
                    authed={authed}
                  />
                  <NavbarLink
                    title="Rewards"
                    href={`${(authed && "/profile?rewards") || "/rewards"}`}
                    authed={authed}
                  />
                  <NavbarLink
                    title="Our Mission"
                    href="why-local-e"
                    authed={authed}
                    privateRoute={true}
                  />
                  <NavbarLink
                    title="Rewards"
                    href={`${(authed && "/profile?rewards") || "/rewards"}`}
                    authed={authed}
                    privateRoute={true}
                  />
                  {/*TODO: ------*/}
                  <NavbarLink
                    title="Login"
                    href="javascript: void(0)"
                    onClickButton={this.handleAuth}
                    section="loginSection"
                    authed={authed}
                  />
                  <NavbarLink
                    title="Register"
                    defaultClass="button"
                    href="javascript: void(0)"
                    onClickButton={this.handleAuth}
                    section="signupSection"
                    authed={authed}
                  />
                  <NavbarLink
                    title={(user && `${user.firstName} ${user.lastName}`) || ""}
                    href="javascript:void(0)"
                    defaultClass="dropdown"
                    onClickButton={this.handleLogout}
                    privateRoute={true}
                    authed={authed}
                  />
                  <NavbarLink
                    title={`${(user && user.points) || 0} eCoins`}
                    href="/profile?rewards"
                    defaultClass="nav-points"
                    privateRoute={true}
                    onClickButton={() =>
                      mixpanel.track("Header Points Label Click")
                    }
                    authed={authed}
                  />
                  {/*TODO: refactor here*/}
                  {(itemCount && (
                    <NavbarLink
                      title={`£${parseFloat(allAmount).toFixed(2)}`}
                      href="/checkout"
                      defaultClass="basket-header"
                      authed={authed}
                      itemCount={itemCount}
                    />
                  )) || <noscript />}
                  {(itemCount && (
                    <NavbarLink
                      title={`£${parseFloat(allAmount).toFixed(2)}`}
                      href="/checkout"
                      defaultClass="basket-header"
                      authed={authed}
                      privateRoute={true}
                      itemCount={itemCount}
                    />
                  )) || <noscript />}
                  {/*TODO: ------*/}
                </ul>
              );
            }}
          </GlobalConsumer>
        </div>
      </nav>
    );
  }
}
export default Navbar;
